module.exports = __webpack_public_path__ + "904090bbeaa23d538edba3c1cd14a041.svg";